import {
  getCopilotAppInstallUrl as getSharedCopilotAppInstallUrl,
  getRegistryServerUrl as getSharedRegistryServerUrl,
  McpInstallButton,
} from '@github-ui/mcp-install-button'

import type {BaseServer} from '../../types/index'

const COPILOT_APP_ENTRY_POINT = 'dotcom_agent-finder_install'

export const getCopilotAppInstallUrl = (mcp: BaseServer) => {
  return getSharedCopilotAppInstallUrl(mcp, COPILOT_APP_ENTRY_POINT)
}

export const getRegistryServerUrl = (protocol: string, mcp: BaseServer) => {
  return getSharedRegistryServerUrl(protocol, mcp)
}

type Props = {
  mcp: BaseServer
  muted?: boolean
}

export function InstallButton({mcp, muted}: Props) {
  return (
    <McpInstallButton
      mcp={mcp}
      muted={muted}
      copilotAppEntryPoint={COPILOT_APP_ENTRY_POINT}
      analyticsReferrerPath={`/agentfinder/${mcp.name}`}
    />
  )
}
